import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-acessogrupo-grid', grid)
Vue.component('app-acessogrupo-edit', edit)
Vue.component('app-acessogrupo-select', select)
